var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-marker',{staticClass:"MYMARKER",attrs:{"icon":_vm.markerIcon,"lat-lng":_vm.source.position},on:{"click":function($event){return _vm.$emit('onMarkerClick', _vm.source)}}})}
var staticRenderFns = []

export { render, staticRenderFns }